import { SubBody2 } from '@flatsy/core/MaterialUi/Typo/Body'
import { IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './Styles'
import { HeaderBrowserProps } from './Type'

const HeaderBrowser: React.FC<HeaderBrowserProps> = ({ browser, close, setClose }) => {
  const classes = useStyles()
  if (localStorage.getItem('browserInformation') === 'true' || close) {
    return null
  }
  if (!browser.success) {
    return null
  }
  if (browser.isFullSupport) {
    return null
  }

  const closeBrowserInfo = () => {
    localStorage.setItem('browserInformation', 'true')
    setClose(true)
  }

  return (
    <div className={classes.container}>
      <div className={classes.infoWrapper}>
        <>
          <SubBody2 className={classes.info}>
            Le navigateur internet que vous utilisez actuellement est connu pour rencontrer des
            difficultés; pour une expérience fluide, veuillez privilégier un navigateur moderne tel
            que Chrome ou Firefox.{' '}
            <Link
              target="_blank"
              data-cy="showPromoCode"
              to="https://www.google.com/intl/fr_fr/chrome/"
              className={classes.link}
            >
              <Typography className={classes.linkText}>Chrome</Typography>
            </Link>{' '}
            ou{' '}
            <Link
              target="_blank"
              data-cy="showPromoCode"
              to="https://www.mozilla.org/fr/firefox/new/"
              className={classes.link}
            >
              <Typography className={classes.linkText}>Firefox</Typography>
            </Link>
          </SubBody2>
        </>
        {!browser.isFullSupport && (
          <IconButton aria-label="close" color="inherit" size="small" onClick={closeBrowserInfo}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )}
      </div>
    </div>
  )
}

export default HeaderBrowser
